<template>
  <div class="row">
    <div class="small-12 columns">
      <h1>Engineering Branches List</h1>
      <button @click="addEngineeringBranch">Add Engineering Branch</button>
    </div>
    <div class="small-12 columns">
      <div v-for="(branch, i) in branches" :key="i">
        {{ i + 1 }} . {{ branch.name }}
        <span
          class="institution-delete-action link"
          @click="deleteEngineeringBranch(branch)"
          >X</span
        >
        <span
          class="institution-edit-action link"
          @click="editEngineeringBranch(branch)"
          >edit</span
        >
      </div>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      branches: [],
    }
  },
  mounted() {
    this.populateEngineeringBranches()
  },
  methods: {
    editEngineeringBranch(branch) {
      this.$router.push(`/engineering-branches-edit/${branch.id}`)
    },
    deleteEngineeringBranch(branch) {
      this.axios({
        method: "delete",
        url: `${siteConfig.siteURL}engbranch/${branch.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        this.populateEngineeringBranches()
      })
    },
    addEngineeringBranch() {
      this.$router.push("/engineering-branches-add/")
    },
    populateEngineeringBranches() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}engbranch/`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.branches = res.data.items
      })
    },
  },
}
</script>

<style>
.institution-delete-action {
  padding-left: 10px;
  color: red;
  font-size: 0.8em;
  cursor: pointer;
}
.institution-edit-action {
  padding-left: 10px;
  color: blue;
  font-size: 0.8em;
  cursor: pointer;
}
</style>
